import { createSlice, current } from '@reduxjs/toolkit';
import {
	getDistanceUnitList,
	getDistanceUnit,
	addNewDistanceUnit,
	updateDistanceUnit,
	deleteDistanceUnit,
	checkDistanceUnitExists,
} from './thunk';

export const initialState = {
	itemDistanceUnitList: [],
	itemDistanceUnit: null,
	isDistanceUnitLoading: false,
	isDistanceUnitSuccess: false,
	dataDistanceUnit: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const DistanceUnitSlice = createSlice({
	name: 'DistanceUnit',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getDistanceUnitList.pending, state => {
			state.isLoadingList = true;
			state.isDistanceUnitSuccess = false;
		});

		builder.addCase(getDistanceUnitList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemDistanceUnitList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isDistanceUnitSuccess = true;
		});

		builder.addCase(getDistanceUnitList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDistanceUnitSuccess = false;
		});

		builder.addCase(getDistanceUnit.pending, state => {
			state.isDistanceUnitLoading = true;
			state.isDistanceUnitSuccess = false;
		});

		builder.addCase(getDistanceUnit.fulfilled, (state, action) => {
			state.itemDistanceUnit = action.payload;
			state.isDistanceUnitLoading = false;
			state.isDistanceUnitSuccess = true;
		});

		builder.addCase(getDistanceUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDistanceUnitLoading = false;
			state.isDistanceUnitSuccess = false;
		});

		builder.addCase(addNewDistanceUnit.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewDistanceUnit.fulfilled, (state, action) => {
			state.itemDistanceUnitList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewDistanceUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateDistanceUnit.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateDistanceUnit.fulfilled, (state, action) => {
			state.itemDistanceUnitList = state.itemDistanceUnitList.map(
				distanceUnitList =>
					distanceUnitList._id.toString() === action.payload._id.toString()
						? { ...distanceUnitList, ...action.payload }
						: distanceUnitList
			);
			state.statementList = state.statementList.map(distanceUnitList =>
				distanceUnitList._id.toString() === action.payload._id.toString()
					? { ...distanceUnitList, ...action.payload }
					: distanceUnitList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateDistanceUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteDistanceUnit.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteDistanceUnit.fulfilled, (state, action) => {
			state.itemDistanceUnitList = current(
				state.itemDistanceUnitList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteDistanceUnit.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkDistanceUnitExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkDistanceUnitExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkDistanceUnitExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = DistanceUnitSlice.actions;

export default DistanceUnitSlice.reducer;
